export const classNames = (classes: string[]) => {
  return classes.join(' ')
}
